import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormFlex } from '../FormGrid';
import { Link } from '../Link';
import { Seperator } from '../Seperator';
export function DataTableAttachments({ attachmentList, variant, }) {
    return (_jsxs("div", { children: [_jsx(Seperator, { margin: (theme) => theme.spacing(0, 0, 3) }), _jsx(FormFlex, { columnGap: 2, rowGap: 2, children: attachmentList.map((attachment) => (_jsx(Link, { variant: variant || 'body1', href: attachment.href, target: "_blank", customIcon: "document-save", children: attachment.title }, attachment.href))) })] }));
}
